import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthentificationMember, MemberDto, TeamInfo } from '../api/Manipulate/MemberDto';
import { environment } from 'src/environments/environment';
import { SignUpTenantWithoutPassword } from '../api/Manipulate/UserManipulate';
import { WalletDto } from '../api/Manipulate/PlanObjects/WalletDto';
import { TenantCreateDto } from '../api/Manipulate/TenantDto';

export interface PaginatedResponse<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface TeamFilter {
  email?: string;
  name?: string;
  phoneNumber?: string;
  cpfCnpj?: string;
  isBlocked?: boolean;
  isSoftBlocked?: boolean;
  blockedWallet?: boolean;
  planIdentifier?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TenantsService {
  private apiUrl = environment.apiUrl + '/admin-user';

  constructor(private httpClient: HttpClient) { }

  //GET
  public GetInfoTenant(tenantId:string): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/info-tenant/${tenantId}`);
  }
  public listOwners(): Observable<MemberDto[]> {
    return this.httpClient.get<MemberDto[]>(`${this.apiUrl}/list-owners`);
  }
  public GetWalletByTenantId(tenantId:string): Observable<WalletDto> {
    return this.httpClient.get<WalletDto>(`${this.apiUrl}/wallet/${tenantId}`);
  }
  public listTeams(): Observable<TeamInfo[]> {
    return this.httpClient.get<TeamInfo[]>(`${this.apiUrl}/list-teams`);
  }

  public listTeamsPaginated(pageSize: number, pageNumber: number, filter?: TeamFilter): Observable<PaginatedResponse<TeamInfo>> {
    const params: any = {};
    if (filter?.email) params['filter.email'] = filter.email;
    if (filter?.name) params['filter.name'] = filter.name;
    if (filter?.phoneNumber) params['filter.phoneNumber'] = filter.phoneNumber;
    if (filter?.cpfCnpj) params['filter.cpfCnpj'] = filter.cpfCnpj;
    if (filter?.isBlocked !== undefined) params['filter.isBlocked'] = filter.isBlocked;
    if (filter?.isSoftBlocked !== undefined) params['filter.isSoftBlocked'] = filter.isSoftBlocked;
    if (filter?.blockedWallet !== undefined) params['filter.blockedWallet'] = filter.blockedWallet;
    if (filter?.planIdentifier) params['filter.planIdentifier'] = filter.planIdentifier;

    return this.httpClient.get<{ total: number; teams: TeamInfo[]; pageSize: number; currentPage: number }>(
      `${this.apiUrl}/list-teams/${pageSize}/${pageNumber}`,
      { params }
    ).pipe(
      map(response => ({
        items: response.teams,
        totalCount: response.total,
        pageNumber: response.currentPage,
        pageSize: response.pageSize,
        totalPages: Math.ceil(response.total / response.pageSize)
      }))
    );
  }
  public listTeamsBlocked(): Observable<TeamInfo[]> {
    return this.httpClient.get<TeamInfo[]>(`${this.apiUrl}/list-teams-blocked`);
  }
  public listSoftBlock(): Observable<TeamInfo[]> {
    return this.httpClient.get<TeamInfo[]>(`${this.apiUrl}/soft-blocked`);
  }
  public listTeamsUnblocked(): Observable<TeamInfo[]> {
    return this.httpClient.get<TeamInfo[]>(`${this.apiUrl}/list-teams-unblocked`);
  }
  public listTeamsByPlanType(): Observable<TeamInfo[]> {
    return this.httpClient.get<TeamInfo[]>(`${this.apiUrl}/list-teams-by-plantype`);
  }
  public listTeam(tenantId: string): Observable<MemberDto[]> {
    return this.httpClient.get<MemberDto[]>(`${this.apiUrl}/list-members/${tenantId}`);
  }
  public getUserByJwt(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/byJwt`);
  }

  //POST  
  
  public resetPassword(userId:string): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/reset-password/${userId}`, {});
  }
  public signupMember(tenantId: string, data: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/signup-member/${tenantId}`, data);
  }
  public verifyUser(userId: string): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/verify/${userId}`, {});
  }
  public blockUser(email: string): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/block-user/${email}`, {});
  }
  public blockTenant(tenantId: string): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/block-tenant/${tenantId}`, {});
  }
  public sendEmailToken(userId: string): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/send-emailtoken/${userId}`, {});
  }
  public updatePassword(teamMemberId: string, newPassword: string): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/updatePassword/teamMember/${teamMemberId}/${newPassword}`, {});
  }
  public login(credentials: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/login`, credentials);
  }

  
  // public configWallets(tenantId:string): Observable<any> {
  //   return this.httpClient.post(`${this.apiUrl}/config-wallet-without-subscription/${tenantId}`, {});
  // }
  
  // public signupTenant(tenant: SignUpTenantWithoutPassword): Observable<any> {
  //   return this.httpClient.post(`${this.apiUrl}/signup-tenant-withoutpassword`, tenant);
  // }

  public createTenantFreeTrial(tenant: TenantCreateDto, days: number): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/tenant/create-tenant-free-trial/${days}`, tenant);
  }

}
